// src/components/Modelo3D.tsx
import React from 'react';
import '@google/model-viewer';

interface ModeloProps{
	modelo: string;
}

const Modelo3D: React.FC<ModeloProps> = ({modelo}) => {
  return (
    <div style={{ width: '100%', height: '500px' }}>
      <model-viewer
				// src="/Astronaut.glb"
				// src={modelo}
				src={modelo}
				alt="Modelo 3D"
				auto-rotate
				camera-controls
				ar
				style={{ width: '100%', height: '100%' }}
			></model-viewer>

    </div>
  );
};

export default Modelo3D;
